import clients from 'redux/clients'

export const handleCardbrands = async (vendorId, requestdata) => {
  let retorno = await clients.cloudloyalty.client
    .post(`/v1/configurations/payment/type/${vendorId}`, requestdata)
  return retorno.status === 200 ? retorno.data : { type: 'classic' }
}

export const handleInstallments = async (vendorId, requestdata) => {
  let retorno = await clients.cloudloyalty.client
    .post(`/v1/configurations/payment/installments/${vendorId}`, requestdata)
  return retorno.status === 200 ? retorno.data : { type: 'classic' }
}

export const getOriginalId = async sku => {
  let retorno = await clients.cloudloyalty.client
    .get(`/v1/products/skus/${sku}`)
  return retorno.status === 200 ? retorno.data.skus.find(x => x.sku === sku).originalId : 0
}

export default {
  handleCardbrands,
  handleInstallments,
  getOriginalId
}



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/PaymentBrands/PaymentClient.js